export default class {
    _id;
    _inn;
    _name;
    _address;
    _accountNumber;
    _mfo;
    _vatRegCode;
    _pinfl;
    _phoneNumber;
    _userFullName;
    _username;
    _password;
    _createdOn;
    _contractNumber;
    _contractDate;
    _contractDateFrom;
    _contractDateTo;
    _contractSum;
    _sumForMail;
    _sumForOverPaged;
    _contractSignerUnit;
    _contractSignerUnitId;
    _isActive;
    _isLtd;
    _balance;
    _isNotified;
    _branchName;
    _branchCode;
    _hasContractWithGlobalUnit;
    _createdMailsCount;
    _sentMailsCount;
    _unitsCount;

    get id() {
        return this._id
    }

    set id(value) {
        this._id = value
    }


    get name() {
        return this._name
    }

    set name(value) {
        this._name = value
    }

    get address() {
        return this._address
    }

    set address(value) {
        this._address = value
    }

    get inn() {
        return this._inn
    }

    set inn(value) {
        this._inn = value
    }

    get createdOn() {
        return this._createdOn
    }

    set createdOn(value) {
        this._createdOn = value
    }

    get contractNumber() {
        return this._contractNumber
    }

    set contractNumber(value) {
        this._contractNumber = value
    }

    get contractDate() {
        return this._contractDate
    }

    set contractDate(value) {
        this._contractDate = value
    }

    get isActive() {
        return this._isActive
    }

    set isActive(value) {
        this._isActive = value
    }

    get accountNumber() {
        return this._accountNumber;
    }

    set accountNumber(value) {
        this._accountNumber = value;
    }

    get mfo() {
        return this._mfo;
    }

    set mfo(value) {
        this._mfo = value;
    }

    get vatRegCode() {
        return this._vatRegCode;
    }

    set vatRegCode(value) {
        this._vatRegCode = value;
    }

    get phoneNumber() {
        return this._phoneNumber;
    }

    get pinfl() {
        return this._pinfl;
    }

    set pinfl(value) {
        this._pinfl = value;
    }

    set phoneNumber(value) {
        this._phoneNumber = value;
    }

    get userFullName() {
        return this._userFullName;
    }

    set userFullName(value) {
        this._userFullName = value;
    }

    get username() {
        return this._username;
    }

    set username(value) {
        this._username = value;
    }

    get password() {
        return this._password;
    }

    set password(value) {
        this._password = value;
    }

    get contractDateFrom() {
        return this._contractDateFrom;
    }

    set contractDateFrom(value) {
        this._contractDateFrom = value;
    }

    get contractDateTo() {
        return this._contractDateTo;
    }

    set contractDateTo(value) {
        this._contractDateTo = value;
    }

    get contractSum() {
        return this._contractSum;
    }

    set contractSum(value) {
        this._contractSum = value;
    }

    get sumForMail() {
        return this._sumForMail;
    }

    set sumForMail(value) {
        this._sumForMail = value;
    }

    get sumForOverPaged() {
        return this._sumForOverPaged;
    }

    set sumForOverPaged(value) {
        this._sumForOverPaged = value;
    }

    get contractSignerUnit() {
        return this._contractSignerUnit;
    }

    set contractSignerUnit(value) {
        this._contractSignerUnit = value;
    }

    get contractSignerUnitId() {
        return this._contractSignerUnitId
    }

    set contractSignerUnitId(value) {
        return this._contractSignerUnitId = value
    }

    get isLtd() {
        return this._isLtd;
    }

    set isLtd(value) {
        this._isLtd = value;
    }

    get balance() {
        return this._balance;
    }

    set balance(value) {
        this._balance = value;
    }

    get isNotified() {
        return this._isNotified;
    }

    set isNotified(value) {
        this._isNotified = value;
    }

    get branchName() {
        return this._branchName;
    }

    set branchName(value) {
        this._branchName = value;
    }

    get branchCode() {
        return this._branchCode;
    }

    set branchCode(value) {
        this._branchCode = value;
    }

    get hasContractWithGlobalUnit() {
        return this._hasContractWithGlobalUnit;
    }

    set hasContractWithGlobalUnit(value) {
        this._hasContractWithGlobalUnit = value;
    }

    get createdMailsCount() {
        return this._createdMailsCount;
    }

    set createdMailsCount(value) {
        this._createdMailsCount = value;
    }

    get sentMailsCount() {
        return this._sentMailsCount;
    }

    set sentMailsCount(value) {
        this._sentMailsCount = value;
    }

    get unitsCount() {
        return this._unitsCount;
    }

    set unitsCount(value) {
        this._unitsCount = value;
    }
}
